import React from 'react';
import { Paper, Box, Button, TextField, Typography } from '@material-ui/core';
import { Form, Field } from 'react-final-form';
import { uploadTypes } from '../../../../config/constants';
import ImageUploadField from '../ImageUploadField';

const TutorialTab = ({ config, onSave }) => {
  const handleSubmit = (values) => {
    onSave({
      ...config,
      tutorial_background: values.tutorial_background,
      tutorial_modal_bg_color: values.tutorial_modal_bg_color,
      tutorial_cta_color: values.tutorial_cta_color,
      tutorial_first_sentence: values.tutorial_first_sentence,
    });
  };

  const initialValues = {
    tutorial_background: config?.tutorial_background,
    tutorial_modal_bg_color: config?.tutorial_modal_bg_color,
    tutorial_cta_color: config?.tutorial_cta_color,
    tutorial_first_sentence: config?.tutorial_first_sentence,
  };

  return (
    <Paper>
      <Box p={3}>
        <Typography variant="h6" gutterBottom>
          Tutorial Settings
        </Typography>
        <Form
          onSubmit={handleSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <Box display="flex" flexDirection="column" gap={2}>
                <ImageUploadField
                  name="tutorial_background"
                  label="Background Image (shared for all tutorial screens)"
                  uploadType={uploadTypes.wordFinder}
                  helperText="Minimum 375Wx825H"
                />

                <Field name="tutorial_modal_bg_color">
                  {({ input }) => (
                    <Box mt={2}>
                      <TextField
                        label="Modal Background Color"
                        value={input.value}
                        onChange={input.onChange}
                        placeholder="#2f2f2f"
                        helperText="HEX color code (opacity is preserved)"
                        fullWidth
                      />
                      <Box mt={1} display="flex" alignItems="center" gap={1}>
                        <Box
                          width={40}
                          height={40}
                          bgcolor={input.value || '#2f2f2f'}
                          borderRadius={4}
                          border="1px solid #ccc"
                        />
                        <input
                          type="color"
                          value={input.value || '#2f2f2f'}
                          onChange={(e) => input.onChange(e.target.value)}
                          style={{ cursor: 'pointer' }}
                        />
                      </Box>
                    </Box>
                  )}
                </Field>

                <Field name="tutorial_cta_color">
                  {({ input }) => (
                    <Box mt={2}>
                      <TextField
                        label="Tovabb CTA Button Color"
                        value={input.value}
                        onChange={input.onChange}
                        placeholder="#db0a40"
                        helperText="HEX color code"
                        fullWidth
                      />
                      <Box mt={1} display="flex" alignItems="center" gap={1}>
                        <Box
                          width={40}
                          height={40}
                          bgcolor={input.value || '#db0a40'}
                          borderRadius={4}
                          border="1px solid #ccc"
                        />
                        <input
                          type="color"
                          value={input.value || '#db0a40'}
                          onChange={(e) => input.onChange(e.target.value)}
                          style={{ cursor: 'pointer' }}
                        />
                      </Box>
                    </Box>
                  )}
                </Field>

                <Field name="tutorial_first_sentence">
                  {({ input }) => (
                    <Box mt={2}>
                      <TextField
                        label="First Screen Sentence"
                        value={input.value}
                        onChange={input.onChange}
                        multiline
                        rows={3}
                        fullWidth
                        helperText="Max. 480 characters"
                        inputProps={{ maxLength: 480 }}
                      />
                    </Box>
                  )}
                </Field>

                <Box mt={3}>
                  <Button type="submit" variant="contained" color="primary" disabled={submitting}>
                    Save Tutorial Settings
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        />
      </Box>
    </Paper>
  );
};

export default TutorialTab;
